
export default function WhistlerZoning() {
  const zones = [
    {
      zone: 'TA1 - Tourist Accommodation 1',
      allowed: true,
      conditions: 'Full STR permitted. No night limits. Typically hotel-style properties and managed condos.',
      restrictions: 'None'
    },
    {
      zone: 'TA2 - Tourist Accommodation 2',
      allowed: true,
      conditions: 'Full STR permitted. Properties in Whistler Village and resort areas.',
      restrictions: 'None'
    },
    {
      zone: 'TA3 - Tourist Accommodation 3',
      allowed: true,
      conditions: 'STR permitted with some strata restrictions. Check individual building rules.',
      restrictions: 'Strata bylaws may apply'
    },
    {
      zone: 'RS - Residential Single Family',
      allowed: false,
      conditions: 'STR generally not permitted. Long-term rental or owner occupancy required.',
      restrictions: 'Principal residence only'
    },
    {
      zone: 'RM - Residential Multi-Family',
      allowed: false,
      conditions: 'STR restricted. May require special permit and principal residence status.',
      restrictions: 'Strict limitations'
    },
    {
      zone: 'CD - Comprehensive Development',
      allowed: true,
      conditions: 'Varies by specific CD zone. Check property-specific zoning designation.',
      restrictions: 'Case by case'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Zoning Regulations
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Whistler&apos;s Unique Zoning System
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Your property&apos;s zoning designation is the most critical factor in determining STR eligibility. Tourist Accommodation (TA) zones offer the most flexibility.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full bg-[#F8F8F8] rounded-2xl overflow-hidden">
            <thead>
              <tr className="bg-[#505A5A] text-white">
                <th className="px-6 py-4 text-left font-semibold">Zone</th>
                <th className="px-6 py-4 text-center font-semibold">STR Allowed</th>
                <th className="px-6 py-4 text-left font-semibold">Conditions</th>
                <th className="px-6 py-4 text-center font-semibold">Restrictions</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((zone, index) => (
                <tr
                  key={zone.zone}
                  className={`border-b border-[#E5E5E5] ${index % 2 === 0 ? 'bg-white' : 'bg-[#F8F8F8]'}`}
                >
                  <td className="px-6 py-5 font-medium text-[#505A5A]">{zone.zone}</td>
                  <td className="px-6 py-5 text-center">
                    {zone.allowed ? (
                      <span className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                        <i className="ri-check-line"></i> Yes
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-medium">
                        <i className="ri-close-line"></i> No
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-5 text-[#505A5A]/70">{zone.conditions}</td>
                  <td className="px-6 py-5 text-center text-[#505A5A] font-medium">{zone.restrictions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-8">
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-building-4-line text-2xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-3">Whistler Village Properties</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Most properties in Whistler Village and Creekside are zoned TA, making them ideal for STR investment. These areas have established rental pools and management infrastructure.
            </p>
          </div>
          <div className="bg-[#F8F8F8] rounded-2xl p-8">
            <div className="w-12 h-12 bg-[#882629]/10 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-home-smile-line text-2xl text-[#882629]"></i>
            </div>
            <h3 className="text-xl font-semibold text-[#505A5A] mb-3">Residential Neighborhoods</h3>
            <p className="text-[#505A5A]/70 leading-relaxed">
              Areas like Alpine Meadows, Emerald Estates, and White Gold are primarily residential zones with STR restrictions. These properties are intended for long-term housing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
